import { render, staticRenderFns } from "./PuzzleForStudent.vue?vue&type=template&id=563d2484&scoped=true&"
import script from "./PuzzleForStudent.vue?vue&type=script&lang=js&"
export * from "./PuzzleForStudent.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleForStudent.vue?vue&type=style&index=0&id=563d2484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d2484",
  null
  
)

export default component.exports